<template>
    <div v-if="hoverStatus" class="tooltip" 
    :style="`width: ${width}px; top: ${top-height-20}px; left: ${left+20}px`">
      
      <div v-if="dataset == 'Depmap'">
        <div v-if="textObject.type == 'gene'">
          <h4><b>Gene</b></h4>
          <h2>{{textObject.Name}}</h2>
          <div v-if="textObject.value != ''">
            <h4><span style="font-weight: 300">Loading:</span> {{textObject.value}}</h4>
          </div>
        </div>
        <div v-else>
          <h4><b>Function - {{textObject.Name}}</b></h4>
          <h2>{{textObject.display_name}}</h2>
        </div>
        <div>
          <p style="font-size: 8pt; margin-top: 8px; line-height: 0px;">click to view more information</p>
        </div>
      </div>
      <div v-else>
        <div v-if="textObject.type == 'gene'">
          <h4><b>Gene</b></h4>
          <h2>{{textObject.Name}}</h2>
          <div v-if="textObject.value != ''">
            <h4><span style="font-weight: 300">Loading:</span> {{textObject.value}}</h4>
          </div>
        </div>
        <div v-else>
          <h4><b>Function - {{textObject.Name}}</b></h4>
          <h2>{{textObject.display_name}}</h2>
        </div>
        <div>
          <p style="font-size: 8pt; margin-top: 8px; line-height: 10px;">click to view more information</p>
        </div>
      </div>
    </div>
  
</template>

<script>
export default {
  props: { 
    textObject: {
      type: Object,
      required: true
    },
    top: {
        type: Number,
        required: true
    },
    left: {
        type: Number,
        required: true
    },
    dataset: {
        type: String,
        required: true
    },
    hoverStatus: {
        type: Boolean,
        required: true,
        default: false
    }
  },
  data() {
      return {
          width: 250,
          height: 60  
          }
  }
};
</script>

<style scoped>
.tooltip {
    text-decoration:none;
    position:absolute;
    width: 150px;
    background-color: rgb(245, 245, 245);
    color: black;
    text-align: left;
    /* border: 1px solid white; */
    box-shadow: 0px 2px 4px #00000029;
    border-radius: 6px;
    padding: 10px;
    z-index: 250;
    /* this is important so it doesn't flicker */
    pointer-events: none; 
}
p{
  margin-bottom: 0px;
  border:0px;
}

h2{
  margin: 0px; 
  margin-bottom: 0px;
}

h3{
  margin-top: 0px;
  margin-bottom: 6px;
  font-weight: 600;
}

h4{
  margin-top: 0px;
}




</style>